import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export type UseAnpReportsProps<T> = {
  filters?: {
    page?: number;
  };
  mapper?: (data: any) => T;
  resourcePath?: string;
};

export const useAnpReports = <T,>({
  filters: { page } = {},
  mapper = Mapper.default<T>(),
}: UseAnpReportsProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['anpReports', page],
    queryFn: () => privateAxios.get('/anp/reports', {
      params: { page },
    }),
    select: (response: { data: { data: any[]; meta: MetaResponse; }; }) => ({
      data: mapper(response?.data?.data ?? []),
      meta: response?.data?.meta,
    }),
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
